import { IWizTranslationEntry } from "@wizeoo/akm-core-lib";
import { WizDatasource } from "../../../../services/collections/wiz-datasource";

/**
 * Objet d'alimentation du composant de traduction. Contient:
 * - La liste des entrées de traduction à gérer
 * - Le code langue principal: celui utilisé actuellement, à placer en entête
 * - Le code langue par défaut: à alimenter via l'entête si non renseigné
 */
export class WizTranslationData {

  /** Datasource des entrées de traduction */
  private _entryDS: WizDatasource<IWizTranslationEntry>;

  public get entryDS(): WizDatasource<IWizTranslationEntry> {
    return this.getEntryDS();
  }
  public set entryDS(entryDS: WizDatasource<IWizTranslationEntry>) {
    this.setEntryDS(entryDS);
  }
  public getEntryDS(): WizDatasource<IWizTranslationEntry> {
    return this._entryDS;
  }
  public setEntryDS(entryDS: WizDatasource<IWizTranslationEntry>) {
    this._entryDS = entryDS ? entryDS : new WizDatasource<IWizTranslationEntry>();
  }

  /** Code langue de l'utilisateur */
  private _mainLanguageCode: string;
  public get mainLanguageCode(): string {
    return this.getMainLanguageCode();
  }
  public set mainLanguageCode(code: string) {
    this.setMainLanguageCode(code);
  }
  public getMainLanguageCode(): string {
    return this._mainLanguageCode;
  }
  public setMainLanguageCode(code: string) {
    this._mainLanguageCode = code;
  }

  /** Code langue par défaut (BU) */
  private _defaultLanguageCode: string;
  public get defaultLanguageCode(): string {
    return this.getDefaultLanguageCode();
  }
  public set defaultLanguageCode(code: string) {
    this.setDefaultLanguageCode(code);
  }
  public getDefaultLanguageCode(): string {
    return this._defaultLanguageCode;
  }
  public setDefaultLanguageCode(code: string) {
    this._defaultLanguageCode = code;
  }
}
